import DiscountSummaryError from './DiscountSummaryError';
class DiscountSummaryPropertyNotFound extends DiscountSummaryError {
    propertyId;
    constructor(propertyId, options) {
        super('CROWDFUNDING_PROPERTY_NOT_FOUND', options);
        this.propertyId = propertyId;
    }
}
export default DiscountSummaryPropertyNotFound;
